import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpEvent,
  HttpErrorResponse,
  HttpEventType,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { finalize, tap, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";
import { ResponseServiceModel } from "../models/response-service.model";
import { AlertType } from "../models/alert.model";
import { AlertsService } from "../services/alerts.service";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private alertsService: AlertsService,
    private ngxSpinnerService: NgxSpinnerService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // extend server response observable with logging
    return next.handle(req).pipe(
      tap(
        // Succeeds when there is a response; ignore other events
        (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            return "succeeded";
          }
          const reponseEvent = event instanceof HttpResponse ? event : null;
          if (reponseEvent) {
            const response = reponseEvent.body as ResponseServiceModel;
            if (response.result === false && response.control?.show) {
              this.alertsService.alert(
                response.control.alert_type as AlertType,
                response.control.message,
                req.url,
                response.control.code.toString(),
                true
              );
              return throwError(response);
            }

            //TODO: Validar si toca ajustar
            if (
              response.result === true &&
              response.control?.show &&
              (req.url.indexOf("/Sanciones/Crear") !== -1 ||
              req.url.indexOf("/NotificacionesMasivasAdministrador/RedactarMensaje") !== -1 ||
                req.url.indexOf("/UsuarioRolAdministrador/Crear") !== -1 ||
                req.url.indexOf("/sanciones/CambiarEstadoSancion") !== -1 ||
                req.url.indexOf("/PreguntaEncuestaCondicion/Crear") !== -1 ||
                req.url.indexOf("/PreguntaEncuestaCondicion/Actualizar") !==
                -1 ||
                req.url.indexOf(
                  "/DepositarioProvisionalAdministrador/Crear"
                ) !== -1 ||
                req.url.indexOf(
                  "/DepositarioProvisionalAdministrador/Eliminar"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaEncuestaListaValorAdministrador/Crear"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaEncuestaAdministrador/EnlazarPreguntas"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaEncuestaListaValorAdministrador/Actualizar"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaCondicionAdministrador/Crear"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaListaValorAdministrador/crear"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaAdministrador/EnlazarPreguntas"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaCondicionAdministrador/Actualizar"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaListaValorAdministrador/Actualizar"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaEncuestaAdministrador/ActualizarFormulaCondicionBloqueo"
                ) !== -1 ||
                req.url.indexOf(
                  "/PreguntaAdicionalEncuestaAdministrador/ActualizarFormulaCondicionBloqueo"
                ) !== -1 ||
                (req.url.indexOf(
                  "/PreguntaEncuestaAdministrador/"
                ) !== -1 && req.method == 'PUT')||
                (req.url.indexOf(
                  "/PreguntaAdicionalEncuestaAdministrador/"
                ) !== -1 && req.method == 'PUT')||
                (req.url.indexOf(
                  "/PreguntaAdicionalEncuestaAdministrador/"
                ) !== -1 && req.method == 'DELETE')||
                (req.url.indexOf(
                  "/PreguntaEncuestaAdministrador/"
                ) !== -1 && req.method == 'DELETE'))
            ) {
              this.alertsService.alert(
                response.control.alert_type as AlertType,
                response.control.message,
                req.url,
                response.control.code.toString(),
                true
              );
              this.alertsService.alert(
                response.control.alert_type as AlertType,
                response.control.message,
                req.url,
                response.control.code.toString()
              );
            }
          }
          return reponseEvent ? "succeeded" : "";
        },
        // Operation failed; error is an HttpErrorResponse
        (error) => {
          return "failed";
        }
      ),
      catchError((err: HttpErrorResponse) => {
        // if (err.status === 403) {
        // 	sessionStorage.clear();
        // }
        if (err.status === 401) {
          this.authService.logout();
          this.router.navigate(["login"]);
        }
        if (err.error) {
          const response = err.error as ResponseServiceModel;
          if (response.result === false && response.control.show) {
            this.alertsService.alert(
              response.control.alert_type as AlertType,
              response.control.message,
              req.url,
              response.control.code.toString()
            );
          }
        }
        return throwError(err);
      }),
      // Log when response observable either completes or errors
      finalize(() => {
        this.ngxSpinnerService.hide();
      })
    );
  }
}
